import React, {PropsWithChildren, Fragment} from "react";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {type IHocFriendsRedirectController} from "views/components/hoc_friends_redirect/hoc_friends_redirect.controller";
import {useNavigate} from "react-router-dom";

export const HocFriendsRedirect: React.FC<PropsWithChildren> = observer(({children}) => {
	const navigate = useNavigate();
	useViewController<IHocFriendsRedirectController>(Bindings.HocFriendsRedirectController, {
		navigate,
	});

	return <Fragment>{children}</Fragment>;
});
